import React, { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';

import { AuthProvider } from './auth/AuthContext';
import RequireAuth from './auth/RequireAuth';
import { NotificationProvider } from './contexts/NotificationContext';
import ThemeContextWrapper from './components/ThemeWrapper/ThemeWrapper';
import BackgroundColorWrapper from './components/BackgroundColorWrapper/BackgroundColorWrapper';
import DnaLoader from './components/Loading/DnaLoader';

import 'assets/scss/black-dashboard-react.scss';
import 'assets/demo/demo.css';
import 'assets/css/nucleo-icons.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

const AdminLayout = lazy(() => import('layouts/Admin/Admin.js'));
const Login = lazy(() => import('./auth/Login.js'));

const root = createRoot(document.getElementById('root'));

function App() {
  return (
    <ThemeContextWrapper>
      <BackgroundColorWrapper>
        <BrowserRouter>
          <AuthProvider>
            <NotificationProvider>
              <Suspense fallback={<DnaLoader visible height="50" width="50" ariaLabel="dna-loading" />}>
                <Routes>
                  <Route path="/login" element={<Login />} />
                  <Route
                    path="/admin/*"
                    element={(
                      <RequireAuth>
                        <AdminLayout />
                      </RequireAuth>
                    )}
                  />
                  <Route path="*" element={<Navigate to="/admin/orders" replace />} />
                </Routes>
              </Suspense>
            </NotificationProvider>
          </AuthProvider>
        </BrowserRouter>
      </BackgroundColorWrapper>
    </ThemeContextWrapper>
  );
}

root.render(<App />);
